/* eslint-disable */

/**
 * 获取页面名
 */
function getPageName() {
    return window.location.pathname.split('/').pop()
}

/**
 * 获取url参数
 */
function query(key, url) {
    var reg = new RegExp("(^|&|\\?|#)" + key + "=([^&#]*)(&|$|#)", "");
    url = url || document.location.href;
    if (typeof url === "undefined") {
        return;
    }
    var match = url.match(reg);
    if (match) {
        return match[2];
    }
    return "";
}

/**
 *本地存储
 */
function setData(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.setItem(name, value);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.setItem(name, value);
        }
    } catch(e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.set(name, value);
    }
    
    return ''
}

function getData(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.getItem(name);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.getItem(name);
        }
    } catch(e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.get(name);
    }
}

/**
 * 复制内容到剪贴板
 */

function copyToClipboard(str) {
    const el = document.createElement('textarea'),
        range = document.createRange(),
        s = window.getSelection();

    el.value = str;
    el.contenteditable = true;
    el.readonly = false;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();

    range.selectNodeContents(el);

    s.removeAllRanges();
    s.addRange(range);

    el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

    let flag = document.execCommand('copy');
    document.body.removeChild(el);
    
};


// 替换url中的参数值
function replaceUrlParamVal(url, key, val) {
  let re = new RegExp('('+ key+'=)([^&]*)');
  let newUrl = url.replace(re, key+'='+val);
  return newUrl;
}

function generateUUID(salt) {
    let d = new Date().getTime();
    if(salt) {
        d += parseInt(salt)
    }
    let uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random()*16)%16 | 0;
      d = Math.floor(d/16)
      return (c=='x' ? r : (r&0x3|0x8)).toString(16)
    })
    return uuid
}

function hash33(data) {
    let hash = 0,
        seed = 131,
        i = 0,
        len = data.length

    for (i; i < len; i++) {
        hash = hash * seed + data[i].charCodeAt()
        hash = hash & 0x7FFFFFFF
    }
    return hash + "";
}

function getBucket(userId, num = 100){
    return hash33(userId) % num
}


const refer = query('refer')

const ukey = (function() {
    var key = getData('ukey')
    if (key) {
        return key
    } else {
        var d = +new Date()
        d = 'ukey_' + [d, Math.floor(d * Math.random() * Math.random()).toString().slice(-5)].join('')
        setData('ukey', d)
        return d
    }
})()

//版本比较
/**
 * 当a<b返回-1, 当a==b返回0, 当a>b返回1,
 * 约定当a或b非法则返回-1
 */
function compareVersion(a, b) {
    a = String(a).split('.');
    b = String(b).split('.');
    try {
        for (var i = 0, len = Math.max(a.length, b.length); i < len; i++) {
            var l = isFinite(a[i]) && Number(a[i]) || 0,
                r = isFinite(b[i]) && Number(b[i]) || 0;
            if (l < r) {
                return -1;
            } else if (l > r) {
                return 1;
            }
        }
    } catch (e) {
        return -1;
    }
    return 0;
}

function getRandom(l, notEquals){
    if(l == 0){
        console.warning('length 0!')
    }

    let random = Math.round(Math.random() * l)
    if(notEquals){
        while(notEquals.indexOf(random) !== -1){
            random = Math.round(Math.random() * l)
        }
    }
    return random
}

export function transNum (num, toFixNum = 1){
    num = parseFloat(num)
    let re,
        unit = ''
    switch (true) {
        case num === 0 || isNaN(num):
            re = 0;
            break;
        case num < 10000:
            re = num
            unit = ''
            break
        case num < 100000000:
            re = num / 10000
            unit = '万'
            break
        default:
            re = num / 100000000
            unit = '亿'
            break;
    }
    
    re = re.toFixed(toFixNum)
    if(toFixNum === 0){
        return re
    }

    while(re.endsWith('0')){
        re = re.substr(0, re.length - 1)
    }

    if(re.endsWith('.')){
        re = re.substr(0, re.length - 1)
    }
    
    return re + unit;
}

function getBebasFontNum(num, React) {
    if (num === '元') {
      return <span className="icon-Han_Yi"></span>
    }
    
    const numArr = num.toString().split('')
  
    return (
      <div className="bebas-wrapper">
        {
          numArr.map((item, i) => {
            if (item === '.') {
              return <span className="icon-bebasdot" key={i}></span>
            }
            else if(item === '万'){
              return <span className="icon-wan48" key={i}></span>
            }else if(item === '亿'){
              return <span className="icon-yi48" key={i}></span>
            }
            else if(isNaN(Number(item))){
              return <span key={i}>{item}</span>
            }
            
            return <span className={`icon-bebas${item}`} key={i}></span>
          })
        }
      </div>
    )
}

/**
 * 增加或者修改参数
 */
function replaceOrAddSearch(key, value){
    let href = window.location.href
    if(window.location.search){
        let re = new RegExp('('+ key+'=)([^&]*)')
        if(re.test(href)){
            return href.replace(re, key+'='+value)
        }else{
            return `${href}&${key}=${value}`
        }
    }else{
        return `${href}?${key}=${value}`
    }
}
  
function getJumpUrl(url){
    let key = 'refer',
        value = query('refer')
    if(url.indexOf('?') !== -1){
        let re = new RegExp('('+ key+'=)([^&]*)')
        if(re.test(url)){
            return url.replace(re, key+'='+value)
        }else{
            return `${url}&${key}=${value}`
        }
    }else{
        return `${url}?${key}=${value}`
    }
}

function versionCompare(version1, version2) {
    const ver1 = version1.split('.');
    const ver2 = version2.split('.');
    const compareLength = Math.min(ver1.length, ver2.length);
    for (let i = 0 ; i < compareLength ; i ++) {
      const subVersion1 = Number(ver1[i]);
      const subVersion2 = Number(ver2[i]);
      if (subVersion1 < subVersion2) {
        return -1;
      }
      if (subVersion1 > subVersion2) {
        return 1;
      }
    }
    if (ver1.length === ver2.length) {
      return 0;
    }
    return (ver1.length < ver2.length ? -1 : 1);
  }

export {
    setData,
    getData,
    query,
    getPageName,
    copyToClipboard,
    replaceUrlParamVal,
    generateUUID,
    hash33,
    refer,
    ukey,
    compareVersion,
    getRandom,
    getBucket,
    getBebasFontNum,
    replaceOrAddSearch,
    getJumpUrl,
    versionCompare,
}